import "./App.css";

function App() {
  return (
    <div className="App">
      <iframe
        src="https://idahocrm.communitycx.com"
        title="SuiteCRM Embedded View"
        className={`w-full h-full border-2 border-indigo-200 rounded-xl m-2 transition-opacity duration-500`}
        style={{height: "calc(100% - 1rem)", width: "calc(100% - 1rem)"}} // Adjust for the margin
      />
    </div>
  );
}

export default App;
